import { useState } from 'react';

import { Grid } from '@mui/material';
import { useFormikContext } from 'formik';

import { FormikAutocomplete } from '@/components/formik/FormikAutocomplete';
import { FormikText } from '@/components/formik/FormikText';
import { PlacesAutosuggest } from '@/components/placesAutosuggest/PlacesAutosuggest';
import { TSearchResult } from '@/components/placesAutosuggest/types';

import { STATE_ABBREVIATIONS } from '@/mocks/states';

export const BusinessAddressFields = () => {
  const [addressInfo, setAddressInfo] = useState<Partial<TSearchResult>>({
    address: '',
    city: '',
    country: '',
    state: '',
    zip: '',
  });

  const { values, errors, setFieldValue, submitCount } =
    useFormikContext<{ streetAddress: string }>();

  const update = (result: Partial<TSearchResult>) => {
    const updatedState = { ...addressInfo, ...result };
    const { address, city, state, zip, country } = updatedState;
    setFieldValue('city', city);
    setFieldValue('zip', zip);
    setFieldValue('streetAddress', address);
    if (country === 'US') {
      setFieldValue('state', state);
    }
    setAddressInfo(updatedState);
  };

  return (
    <div>
      <PlacesAutosuggest
        name="streetAddress"
        label="formLabels.streetAddress"
        placeholder="signUp.stationLocation.searchStreetAddress"
        error={submitCount > 0 ? errors.streetAddress : undefined}
        initialInputValue={values.streetAddress}
        isFullAddressShown={false}
        setSearchResult={update}
        data-testid="streetAddress"
      />

      <FormikText
        name="secondaryAddress"
        label="formLabels.secondaryAddress"
        data-testid="secondaryAddress"
      />
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <FormikText name="city" label="formLabels.city" data-testid="city" />
        </Grid>

        <Grid item xs={6}>
          <FormikAutocomplete
            name="state"
            options={STATE_ABBREVIATIONS}
            label="formLabels.state"
            data-testid="state"
          />
        </Grid>
      </Grid>

      <FormikText name="zip" label="formLabels.zip" data-testid="zip" />
    </div>
  );
};
